import React from 'react';

import PropTypes from 'prop-types';

import Row from './Row';
import { Th } from '../css';

const Table = ({ data, fetchData }) => {
  return (
    <table data-tableType="regular">
      <thead style={{ background: '#e3e3e3' }}>
        <tr>
          <Th>Domain</Th>
          <Th>Actions</Th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.rows &&
          data.rows.map((rowData, index) => (
            <Row
              key={rowData.id}
              index={index}
              data={rowData}
              fetchData={fetchData}
            />
          ))}
      </tbody>
    </table>
  );
};

Table.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Table;
